module.exports = "https://ssr-releases-cdn.paperlesspost.com/_next/static/images/Block1_Mobile-5deafa2215d3c76c291af4bd8ebbd2f9.png";